import React, { lazy, Suspense, useEffect, useState } from 'react'

function Shield() {
    return <div>Shield</div>
}

export default Shield
